/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_RkidInputs */

const cs_projects_rkid = /** @type {(inputs: Projects_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK ID projektu`)
};

const en_projects_rkid = /** @type {(inputs: Projects_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project RK ID`)
};

/**
* | output |
* | --- |
* | "Project RK ID" |
*
* @param {Projects_RkidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_rkid = /** @type {((inputs?: Projects_RkidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_RkidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_rkid(inputs)
	return cs_projects_rkid(inputs)
});